import { classNameMerger } from '@breetometer/utils';
import type { ReactNode } from 'react';

import { type IStatusIcon, STATUS_PILL_CONFIG } from './helpers';

export const StatusIcon = ({ status = 'successful', text, ...rest }: IStatusIcon) => {
	const isBooleanStatus = (statusArg: boolean) => typeof status === 'boolean' && status === statusArg;

	const pillConfig = typeof status !== 'boolean' ? STATUS_PILL_CONFIG[status] : undefined;

	const defaultStatus = status ? 'Successful' : 'Failed';
	const ariaLabel = text ?? (typeof status === 'boolean' ? defaultStatus : status);

	if (pillConfig) {
		const { className, bgFill, stroke, dotFill, textFill, labelPath } = pillConfig;

		const width = text ? Math.ceil(text.length * 6 + 32) : pillConfig.width;

		const label: ReactNode = text ? (
			<text
				x='19'
				y='12'
				dominantBaseline='central'
				fontFamily='inherit'
				fontSize='12'
				fontWeight='500'
				fill={textFill}
				className='text-path'
			>
				{text}
			</text>
		) : (
			<path
				d={labelPath}
				fill={textFill}
				className='text-path'
			/>
		);

		return (
			<svg
				width={width}
				height='24'
				viewBox={`0 0 ${width} 24`}
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				role='img'
				aria-label={ariaLabel}
				{...rest}
				className={classNameMerger(className, rest.className)}
				data-testid='status-icon'
			>
				<rect
					x='0.25'
					y='0.25'
					width={width - 0.5}
					height='23.5'
					rx='11.75'
					fill={bgFill}
				/>
				<rect
					x='0.25'
					y='0.25'
					width={width - 0.5}
					height='23.5'
					rx='11.75'
					stroke={stroke}
					strokeWidth='0.5'
				/>
				<circle
					cx='10'
					cy='12'
					r='3'
					fill={dotFill}
				/>
				{label}
			</svg>
		);
	}

	if (isBooleanStatus(true))
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				role='img'
				aria-label={ariaLabel}
				{...rest}
				className='status-icon-success'
			>
				<rect
					width='24'
					height='24'
					rx='12'
					fill='#21CE6B'
				/>
				<g clipPath='url(#clip0_10830_206823)'>
					<path
						d='M10.6665 14.1145L16.7945 7.98584L17.7378 8.92851L10.6665 15.9998L6.42383 11.7572L7.3665 10.8145L10.6665 14.1145Z'
						fill='white'
					/>
				</g>
				<defs>
					<clipPath id='clip0_10830_206823'>
						<rect
							width='16'
							height='16'
							fill='white'
							transform='translate(4 4)'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	if (isBooleanStatus(false))
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				role='img'
				aria-label={ariaLabel}
				{...rest}
			>
				<rect
					width='24'
					height='24'
					rx='12'
					fill='#DF3939'
				/>
				<g clipPath='url(#clip0_10830_206880)'>
					<path
						d='M12 11.0573L15.3 7.75732L16.2427 8.69999L12.9427 12L16.2427 15.3L15.3 16.2427L12 12.9427L8.69999 16.2427L7.75732 15.3L11.0573 12L7.75732 8.69999L8.69999 7.75732L12 11.0573Z'
						fill='white'
					/>
				</g>
				<defs>
					<clipPath id='clip0_10830_206880'>
						<rect
							width='16'
							height='16'
							fill='white'
							transform='translate(4 4)'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	return <></>;
};
